export const constants = {
    LOCAL_NETWORK_NAME: 'local',
    PRIVATE_NET_WIF: 'L4qhHtwbiAMu1nrSmsTP5a3dJbxA3SNS6oheKnKd8E7KTJyCLcUv',
    PRIVATE_NET_PRIVATE_KEY: 'e35fa5d1652c4c65e296c86e63a3da6939bc471b741845be636e2daa320dc770',
    PRIVATE_NET_PUBLIC_KEY: '0248be3c070df745a60f3b8b494efcc6caf90244d803a9a72fe95d9bae2120ec70',
};

//# sourceMappingURL=constants.js.map
